<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-添加
    -->
  <el-dialog title="添加轮播图" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="轮播标题" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="轮播类型" prop="type" :label-width="formLabelWidth">
        <el-select size="small" v-model="form.type" placeholder="请选择">
          <el-option label="用户端" :value="1"></el-option>
          <el-option label="技师端" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="轮播图片" prop="image" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.image!=''" class="img">
            <img :src="form.image" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="链接" prop="url" :label-width="formLabelWidth">
        <el-input v-model="form.url" placeholder="请输入要跳转的外链"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>

</template>

<script>
import RotationApi from "@/api/rotation.js";
import Upload from "@/components/file/Upload";

export default {
  components: {
    Upload
  },
  data() {
    return {
      bannerclass: [],
      form: {
        banner_id: "",
        url: "",
        name: "",
        sort: 100,
        imageId: "",
        image: "",
        type: 1
      },

      formRules: {
        name: [
          {
            required: true,
            message: "请输入轮播标题",
            trigger: "blur"
          }
        ],
        image: [
          {
            required: true,
            message: "请上传轮播图片",
            trigger: "blur"
          }
        ],
        sort: [
          {
            required: true,
            message: "排序不能为空"
          },
          {
            type: "number",
            message: "排序必须为数字"
          }
        ]
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false
    };
  },
  props: ["open_add", "addform"],
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    /*添加用户*/
    addUser() {
      let self = this;
      let params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          RotationApi.rotationAdd(params)
            .then(data => {
              // console.log("添加轮播图片==》", data);
              self.loading = false;
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.image = e[0].filePath;
        this.form.imageId = e[0].fileId;
      }
      this.isupload = false;
    }
  }
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/rotation/Add.vue